import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { deleteSupportChatModuleTagAPI } from '../../../api/supportChatModuleTags';
import SupportWidgetKeys from '../../SupportWidget/queryKeys';

const { getTagsList } = SupportWidgetKeys;

const useDeleteSupportChatModuleTagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(data => deleteSupportChatModuleTagAPI(data), {
    onSuccess: () => {
      // Invalidate both the management table query and the filter query
      queryClient.invalidateQueries(['supportChatModuleTags']);
      queryClient.invalidateQueries([getTagsList]);
      message.success('Tag deleted successfully');
    },
    onError: error => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to delete tag';
      message.error(errorMessage);
    },
  });
};

export default useDeleteSupportChatModuleTagMutation;
